<div
  role="group"
  class="flex items-start gap-(--space-2) px-(--space-3) py-(--space-2) bg-[var(--surface-0)] border border-[var(--border)] rounded-[var(--radius-md)]"
  [attr.aria-label]="'graphs.measureChip.measureAria' | transloco: { name: measure().name }">
  @if (nameClickable()) {
    <button
      type="button"
      (click)="change.emit()"
      class="font-medium text-[var(--text-color)] cursor-pointer transition-all focus:outline-none focus:ring-2 focus:ring-[var(--p-primary-ui)] focus:ring-offset-1 rounded-sm py-2"
      [attr.aria-label]="'graphs.measureChip.changeAria' | transloco: { name: measure().name }">
      {{ measure().name }}
    </button>
  } @else {
    <span class="font-medium text-[var(--text-color)] py-2">{{ measure().name }}</span>
  }

  <button
    type="button"
    (click)="configure.emit()"
    class="flex items-center justify-center h-11 w-11 rounded hover:bg-[var(--surface-hover)] cursor-pointer transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--p-primary-ui)] focus:ring-offset-2 flex-shrink-0"
    [attr.aria-label]="'graphs.measureChip.configureAria' | transloco: { name: measure().name }">
    <i class="pi pi-cog text-base" aria-hidden="true"></i>
  </button>

  <button
    type="button"
    (click)="remove.emit()"
    class="flex items-center justify-center h-11 w-11 rounded hover:bg-[var(--surface-hover)] cursor-pointer transition-colors focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 flex-shrink-0"
    [attr.aria-label]="'graphs.measureChip.removeAria' | transloco: { name: measure().name }">
    <i class="pi pi-times text-base text-red-600" aria-hidden="true"></i>
  </button>
</div>
